<template>
  <withTopNav leftText="Histórico" fixed>
    <div class="flex flex-col h-[100vh]">
      <!-- 日期过滤器 -->
      <div class="flex items-center justify-between px-4 py-3">
        <div class="flex text-[14px] items-center">
          <span class="text-white">Bonus</span>
          <span class="text-[#FFDF12] font-bold text-[16px] mx-1">
            {{ historyAmount }}
          </span>
        </div>
        <div
          className="flex justify-center items-center"
          @click="
            () => {
              dateFilterModal = true;
              activeDateValue = currentDate.value;
            }
          "
        >
          <span class="text-white text-[13px]">{{ currentDate?.label }}</span>
          <Image :src="down_arrow" class="w-6 h-6 ml-1" />
        </div>
      </div>
      <div className="px-4  pb-8">
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :loading-text="$t('Common.Loading')"
          @load="getHistoryList"
        >
          <DataTable :columns="columns" :round="true" :data="historyList" />
        </van-list>
      </div>

      <!-- 日期筛选模态框 -->
      <van-popup
        v-model:show="dateFilterModal"
        position="bottom"
        class="w-full bg-[#151A1F] bottom-0 rounded-t-[24px]"
      >
        <div
          class="w-full h-[44px] text-[15px] flex justify-center items-center bg-[#2C7952]/70 text-[#fff] sticky top-0 rounded-t-[10px]"
        >
          <span>Condições de Filtro</span>
        </div>
        <p class="text-[#fff] text-[15px] mt-[10px] px-[40px]">Selecionar Tempo</p>
        <div class="px-[30px] flex justify-between flex-wrap mt-[10px] gap-y-[10px]">
          <button
            v-for="item in dateOptions"
            :key="item.value"
            @click="activeDateValue = item.value"
            :class="[
              'w-[150px] h-[44px] text-[13px] rounded-[8px] border-0',
              activeDateValue === item.value
                ? 'bg-[#2C7952]/40 text-[#fff]'
                : 'bg-[#2C7952]/20 text-[#fff]/65',
            ]"
          >
            {{ item.label }}
          </button>
        </div>

        <div class="mx-[30px] my-8">
          <PopupFooter
            :onCancel="() => (dateFilterModal = false)"
            :onConfirm="
              () => {
                dateFilterModal = false;
                currentDate = dateOptions.find((item) => item.value === activeDateValue);
                pageOptions.value = {
                  page: 1,
                  size: 20,
                };
                historyList = [];
              }
            "
          />
        </div>
      </van-popup>
    </div>
  </withTopNav>
</template>

<script setup lang="tsx">
import withTopNav from "@/layouts/withTopNav.vue";
import PopupFooter from "@a/components/PopupFooter/index.vue";
import DataTable from "@a/components/DataTable/index.vue";
import { getRebateHistoryList } from "@/api/rebate";
import { formatter } from "@/utils";
import { dateOptions } from "./contants";
import down_arrow from "./../images/down_arrow.png";
import debounce from "lodash-es/debounce";
import dayjs from "dayjs";
const route = useRoute();
const activityId = route.query.activityId;
const dateFilterModal = ref(false);
const historyAmount = ref(0);
const currentDate = ref(dateOptions[0]) as any;
const activeDateValue = ref(dateOptions[0].value);
const finished = ref(false);
const loading = ref(false);
const columns = [
  {
    title: "Tempo",
    key: "time",
    render: (row: any) => (
      <div class="text-13 flex-center size-full">
        {dayjs(row.updateTime).format("DD/MM/YYYY")}
      </div>
    ),
  },
  {
    title: "Evento",
    key: "activityType",
    render: (row: any) => (
      <div class="text-13 text-center flex-center size-full">{row.activityType}</div>
    ),
  },
  {
    title: "Bonus",
    key: "rewardAmount",
    render: (row: any) => (
      <div class="text-13 flex-center size-full text-[#64F765]">
        {formatter().format(row.rewardAmount)}
      </div>
    ),
  },
];

const pageOptions = ref<any>({
  page: 1,
  size: 10,
});
// 表格数据
const historyList = ref<any[]>([]);
// 获取历史列表
const getHistoryList = debounce(async () => {
  if (finished.value) return;
  loading.value = true;
  try {
    const result: any = await getRebateHistoryList({
      range: activeDateValue.value,
      page: pageOptions.value.page,
      size: pageOptions.value.size,
      activityId,
    });

    if (result.code === 1) {
      historyAmount.value = result.data.totalAmount || 0;
      historyList.value = [...historyList.value, ...result.data.data];
      if (historyList.value.length >= Number(result.data.total)) {
        finished.value = true;
      } else {
        pageOptions.value.page += 1;
      }
    }
  } finally {
    loading.value = false;
  }
}, 300);

watch(currentDate, () => {
  pageOptions.value = {
    page: 1,
    size: 10,
  };
  historyList.value = [];
  finished.value = false;
  getHistoryList();
});
</script>

<style lang="scss" scoped></style>
